module.exports = __webpack_public_path__ + "static/media/view7.c483714e.jpg";